module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "10em"
    }
  }, [_c('i', {
    staticClass: "fa fa-bug",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 403")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "4em"
    }
  }, [_vm._v("PAGE FORBIDDEN")]), _vm._v(" "), _c('h1', [_vm._v("Bạn không có quyền thực hiện tác vụ này!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-799e5f06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/permissiondenied/PermissionDenied.vue
// module id = 723
// module chunks = 1